// extracted by mini-css-extract-plugin
module.exports = {"Tutorials":"Tutorials_Tutorials__1z6Ol","Link":"Tutorials_Link__9dRZl"};